import script from "./StaticWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./StaticWidget.vue?vue&type=script&setup=true&lang=js"

import "./StaticWidget.vue?vue&type=style&index=0&id=64b1bd94&lang=scss"

const __exports__ = script;

export default __exports__